import axios from "axios";
import Config from "../../utils/Config";
const baseUrl = Config.baseUrl;

// NOTE: getBirthdays / getBirthdaySettings / updateBirthdaySettings now point
// at real, confirmed backend endpoints. sendBirthdayBlast is still a
// placeholder — that endpoint's real spec hasn't been provided yet.
class BirthdayRequests {
  getHeaders() {
    return {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${localStorage.getItem(
        "txtconnect_ng_user_token"
      )}`,
    };
  }

  // Real endpoint, confirmed: GET api/user/birthday/contacts?filter=&page=&limit=
  // filter is one of "today" | "week" | "month".
  async getBirthdays(filter = "today", page = 1, limit = 15, search = "") {
    try {
      const params = new URLSearchParams({
        filter,
        page: page.toString(),
        limit: limit.toString(),
        ...(search && { search }),
      });

      const response = await axios.get(
        `${baseUrl}api/user/birthday/contacts?${params.toString()}`,
        { headers: this.getHeaders() }
      );
      return {
        success: true,
        data: response.data,
        status: response.status,
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data || error.message,
        status: error.response?.status || 500,
      };
    }
  }

  // Real endpoint, confirmed: GET api/user/birthday/settings
  // response data.data.data: { id, user_slug, sender_id, message, created_at, updated_at }
  async getBirthdaySettings() {
    try {
      const response = await axios.get(`${baseUrl}api/user/birthday/settings`, {
        headers: this.getHeaders(),
      });
      return {
        success: true,
        data: response.data,
        status: response.status,
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data || error.message,
        status: error.response?.status || 500,
      };
    }
  }

  // Real endpoint, confirmed: api/user/birthday/settings
  // settingsPayload: { sender_id: string, message: string }
  // TODO: HTTP method not explicitly confirmed — using PUT (REST convention
  // for "update"). The response includes both created_at and updated_at,
  // which hints this could be an upsert-style endpoint expecting POST
  // instead. Switch to axios.post below if PUT 404s/405s against the real API.
  async updateBirthdaySettings(settingsPayload) {
    try {
      const response = await axios.post(
        `${baseUrl}api/user/birthday/settings`,
        settingsPayload,
        { headers: this.getHeaders() }
      );
      return {
        success: true,
        data: response.data,
        status: response.status,
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data || error.message,
        status: error.response?.status || 500,
      };
    }
  }

  // TODO: placeholder endpoint — swap for the real "send birthday blast"
  // endpoint once the backend provides one.
  //
  // Payload carries full per-recipient contact records (phone_number,
  // first_name, last_name, email) rather than a bare msisdns list. This is
  // deliberate: the message can contain {{first_name}} etc. tokens, and
  // those can only be resolved server-side if the request carries the data
  // to resolve them from — the same way the real, working sendBulkSms
  // resolves variables from contact_group_slugs (contacts the backend
  // already owns). sendQuickSms's msisdns-only shape was the wrong model to
  // copy here for that reason: it has no contact context, which is exactly
  // why MessageComposer.jsx's variable-insert buttons are never enabled for
  // Quick SMS, only Bulk SMS.
  async sendBirthdayBlast({ contacts, content, sender_id }) {
    try {
      const cleanedContacts = (contacts || []).map((contact) => ({
        phone_number: (contact.phone_number || "").toString().replace(/\D/g, ""),
        first_name: contact.first_name || "",
        last_name: contact.last_name || "",
        email: contact.email || "",
      }));
      const response = await axios.post(
        `${baseUrl}api/user/send/birthday/sms`,
        { contacts: cleanedContacts, content, sender_id },
        { headers: this.getHeaders() }
      );
      return {
        success: true,
        data: response.data,
        status: response.status,
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data || error.message,
        status: error.response?.status || 500,
      };
    }
  }
}

const birthdayRequests = new BirthdayRequests();
export default birthdayRequests;
